import {
  Alert,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Tooltip,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,	
} from "@mui/material";
import { useState, useEffect } from "react";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { theme } from "../../theme";
import { auth } from "../../utils/FireBaseConfigurations/config";
import FileUploader from "../../components/FileUploader";
import pagebg from "../../assests/pagebg.png";
import AuthForm from "../../components/DialogBox/DialogContents/AuthForm";
import DialogBox from "../../components/DialogBox";
import AuthDialogBox from "../../components/DialogBox/AuthDialogBox";
import CreditsRequestsForm from "../../components/DialogBox/DialogContents/CreditsRequestForm";
import ThankyouMessage from "../../components/DialogBox/DialogContents/ThankyouMessage";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import CheckIcon from "@mui/icons-material/Check";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import ForgotPasswordForm from "../../components/DialogBox/DialogContents/ForgotPasswordForm";
import herobg from "../../assests/herobg.jpg";
import trueidlogowhite from "../../assests/TrueID-logo-white.png";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallIcon from "@mui/icons-material/Call";
import kyc_icon from "../../assests/kyc.svg";
import mfa_icon from "../../assests/mfa.svg";
import facial_analytics_icon from "../../assests/facialanalytics.svg";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useNavigate } from "react-router-dom";
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';


const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
 
const solutions = [
  {
    title: "Digital KYC & Onboarding",
    subtitle: "Seamless ID verification at scale",
    description:
      "Enable instant, compliant onboarding through biometric validation, document checks, and AI-driven risk signals.",
    icon: kyc_icon,	  
  },
  {
    title: "Multi-Factor Authentication (MFA)",
    subtitle: "Layered security for trusted access",
    description:
      "Leverage advanced models to estimate age, gender, detect deepfakes, and flag NSFW or manipulated imagery in real time.",
    icon: mfa_icon,
  },
  {
    title: "Facial Analytics & Insights",
    subtitle: "Intelligence beyond verification",
    description:
      "Leverage advanced models to estimate age, gender, detect deepfakes, and flag NSFW or manipulated imagery in real time.",
    icon: facial_analytics_icon,
  },
];
 
const MainPage = () => {
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("signup");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [userCredits, setUserCredits] = useState(null);
  const [creditsLoading, setCreditsLoading] = useState(false);
  const [creditsError, setCreditsError] = useState("");
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);	
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [notification, setNotification] = useState({ open: false, message: "", severity: "success" });
  const navigate = useNavigate();
  const showNotification = (message, severity = "success") => {
    setNotification({ open: true, message, severity });
  };
const [isFormAlreadySubmitted, setIsFormAlreadySubmitted] = useState(false);
const [contactSignupData, setContactSignupData] = useState(null);
  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };
  const fetchUserCredits = async (retryCount = 0) => {
    const accessToken = localStorage.getItem("access_token");


    // Helper to refresh backend token using current Firebase session
    const refreshBackendToken = async () => {
      const user = auth.currentUser;
      if (!user) throw new Error("NO_FIREBASE_SESSION");
      const providerId = user.providerData?.[0]?.providerId || "password";
      let resp;
      if (providerId === "password") {
        console.info("[Auth] Attempting access token refresh using refresh_token (email/password user)");
        const storedRefresh = localStorage.getItem("refresh_token");
        if (!storedRefresh) throw new Error("PASSWORD_USER_RELOGIN_REQUIRED");
        resp = await fetchWithTimeout(
          `${BACKEND_URL}/auth/refresh`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refresh_token: storedRefresh }),
          },
          30000
        );
      } else {
        // For OAuth users (e.g., google.com), backend uses UID as password
        console.info("[Auth] Attempting silent re-login using OAuth UID (provider:", providerId, ")");
        resp = await fetchWithTimeout(
          `${BACKEND_URL}/auth/loginUser`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: user.email, password: user.uid }),
          },
          30000
        );
      }
      if (!resp.ok) throw new Error("REFRESH_FAILED");
      const data = await resp.json();
      localStorage.setItem("access_token", data.access_token);
      if (data.refresh_token) localStorage.setItem("refresh_token", data.refresh_token);
      return data.access_token;
    };


    if (!accessToken) {
      // Try silent refresh once if Firebase session still exists
      try {
        const newToken = await refreshBackendToken();
        // Retry immediately with the new token
        return await fetchUserCredits(retryCount);
      } catch (e) {
        if (retryCount < 3) {
          setTimeout(() => fetchUserCredits(retryCount + 1), 1000);
          return;
        }
        setSessionExpired(true);
        setCreditsError("");
        setUserCredits(0);
	return;
      }
    }
 
    setCreditsLoading(true);
    setCreditsError("");
 
    try {
      const response = await fetchWithTimeout(
        `${BACKEND_URL}/user/userCredits`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        },
        30000 // 30 second timeout
      );
 
      if (!response.ok) {
        // Handle 401 Unauthorized - try refresh-and-retry once
        if (response.status === 401) {
          try {
            const newToken = await refreshBackendToken();
            const retryResp = await fetchWithTimeout(
              `${BACKEND_URL}/user/userCredits`,
              {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${newToken}`,
                  "Content-Type": "application/json",
                },
              },
              30000
            );
            if (!retryResp.ok) throw new Error("RETRY_FAILED");
            const retryData = await retryResp.json();
            setUserCredits(retryData.credits || retryData.user_credits || 0);
            return;
          } catch (e) {
            localStorage.removeItem("access_token");
            setSessionExpired(true);
            setCreditsError("");
            setUserCredits(0);
            return;
          }
        }
        // For other errors, throw to be caught by catch block
        throw new Error(`Failed to fetch user credits: ${response.status}`);
      }
 
      const data = await response.json();
      setUserCredits(data.credits || data.user_credits || 0);
      setSessionExpired(false);
      setCreditsError("");
    } catch (err) {
      console.error("Error fetching user credits:", err);
     
      // Handle different error types
      if (err.name === "TimeoutError") {
        setCreditsError("Request timeout - please try again");
      } else if (err.message.includes("401")) {
        // Session expired
        setSessionExpired(true);
        setCreditsError("");
	localStorage.removeItem("access_token");
      } else {
        setCreditsError(err.message || "Unable to load credits");
      }
      setUserCredits(0); // Set to 0 instead of null to avoid display issues
    } finally {
      setCreditsLoading(false);
    }
  };
 
  useEffect(() => {
    // Listen to Firebase auth state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsLoggedIn(true);
        setCurrentUser(user);
        fetchUserCredits();
      } else {
        setIsLoggedIn(false);
        setCurrentUser(null);
        setUserCredits(null);
        setCreditsError("");
	setSessionExpired(false);
      }
    });
 
    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);
 
  const handleRegisterClick = (prefillData = null) => {
    setContactSignupData(prefillData);
    setOpen(true);
    setDialogContent("signup");
  };
 
  const handleSigninClick = () => {
    setOpen(true);
    setDialogContent("signin");
  };


const handleSessionExpired = () => {
    setSessionExpired(true);
    setUserCredits(0);
    setCreditsError("");
    localStorage.removeItem("access_token");
  };
/*
    try {
      const response = await fetchWithTimeout(
        `${BACKEND_URL}/auth/refresh`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refresh_token: refreshToken }),
        },
        30000
      );
 
      if (!response.ok) throw new Error("FAILED_REFRESH");
 
      const data = await response.json();
      if (data.access_token) {
        localStorage.setItem("access_token", data.access_token);
      }
      if (data.refresh_token) {
        localStorage.setItem("refresh_token", data.refresh_token);
      }
 
      window.location.reload();
    } catch (err) {
      console.error("Session refresh failed:", err);
      localStorage.removeItem("access_token");
      setSessionExpired(true);
      setUserCredits(0);
      setCreditsError("");
    }
  };*/


  const handleCreditsRequest = () => {
    setOpen(true);
    setDialogContent("request for credits");
  };
 
  const handleNext = () => {
    setDialogContent("thank you message");
  };
 
  const handleClose = () => {
    setOpen(false);
    setContactSignupData(null);
  };


  const handleForgotPassword = () => {
    setDialogContent("forgotPassword");
  };
 
  const handleAuthSuccess = () => {
    handleClose();
    // Trigger credits fetch after successful authentication
    // Small delay to ensure token is saved to localStorage
    console.log("Auth successful - fetching credits...");
    setTimeout(() => {
      console.log("Calling fetchUserCredits from handleAuthSuccess");
      fetchUserCredits();
    }, 500);
    // Note: onAuthStateChanged will also handle the login state and user info
  };
 
  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };
 
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };
 
  const handleSignout = async () => {
    handleMenuClose(); // Close the menu first
 
    try {
      // Sign out from Firebase
      await signOut(auth);
 
      // Clear localStorage
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("admin_email");


      // Reset UI state
      setIsLoggedIn(false);
      setCurrentUser(null);
      setUserCredits(null);
      setCreditsError("");
      setCreditsLoading(false);
 
      // Show success message
      showNotification("Logged out successfully", "success");
    } catch (error) {
      console.error("Signout error:", error);
      showNotification("Error logging out. Please try again.", "error");
    }
  };
 
 
  return (
    <Grid
      sx={{
        backgroundImage: `url(${herobg})`,
        backgroundSize: "cover",
        height: "100vh",
        backgroundRepeat: "no-repeat",
        justifyContent: "center",
        padding: "0px 25px",
	backgroundPosition: "center",
        height: "120vh",
      }}
    >
      {/* header */}
      <Grid
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: { xs: "8px 4px", sm: "10px 8px", md: "5px 5px" },
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: { xs: "none", sm: "flex" },
            justifyContent: "flex-start",
            gap: 0.5,
          }}
        >
          <Button
            sx={{
              color: "#fff",
              textTransform: "none",
              fontFamily: "Inter, sans-serif",
              fontSize: { sm: "12px", md: "14px" },
              padding: { sm: "6px 8px", md: "6px 16px" },
              minWidth: "auto",
              whiteSpace: "nowrap",
	      textDecoration: "underline",
	      display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
            }}
            onClick={() => (window.location.href = "mailto:info@trueid.in")}
          >
	  <EmailIcon sx={{ color: "#fff", mr:0.5, fontSize: 18 }} />{" "}
          info@trueid.in
          </Button>


	  <IconButton
                  onClick={handleCreditsRequest}
                  sx={{
                    backgroundColor: "#2586af",
                    "&:hover": { backgroundColor: "#2586af", opacity: 0.9 },
                    borderRadius: "50px",
                    padding: { md: "6px 12px" },
                    gap: 0.5,
                    height: { md: "auto" },
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#fff",
                      fontFamily: "Inter, sans-serif",
                      fontSize: { md: "14px" },
	              display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    Inquire Now
                  </Typography>
                </IconButton>
 
        </Box>
 
        {/* Mobile menu icon for left section */}
        <Box
          sx={{
            flex: 1,
            display: { xs: "flex", sm: "none" },
            justifyContent: "flex-start",
          }}
        >
          <IconButton
            onClick={handleMenuOpen}
            sx={{
              backgroundColor: "#2586af",
              color: "#fff",
              "&:hover": { backgroundColor: "#2586af", opacity: 0.9 },
              padding: "6px",
            }}
          >
            <MenuIcon sx={{ fontSize: "20px" }} />
          </IconButton>
        </Box>
 
        <Box
          sx={{
            flex: { xs: 0.8, sm: 1 },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
	    onClick={() => window.open("https://www.trueid.in/", "_blank")}
            src={trueidlogowhite}
            alt="TrueID Logo"
            sx={{ height: { xs: "35px", sm: "45px", md: "60px" }, cursor: "pointer" }}
          />
        </Box>
 
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            alignItems: "center",
          }}
        >
          {isLoggedIn && currentUser ? (
            <>
              {/* Desktop view - show buttons directly */}
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  gap: 1,
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    textTransform: "none",
                    fontFamily: "Inter, sans-serif",
                    fontSize: { md: "15px" },
		    alignItems: "center",
	            display: "inline-flex",
	            lineHeight: 1,
                  }}
                >
		  <PersonIcon sx={{color:"#fff", mr:0.5, fontSize:18, verticalAlign: "middle"}}/>
                  {currentUser.displayName ||
                    currentUser.email ||
                    "User"}
                </Typography>
                {currentUser.email.endsWith("@trueid.in") && (
                  <IconButton
		      onClick={() => {
                      // Set admin_email if user has @trueid.in email and access_token
                      const token = localStorage.getItem("access_token");
                      if (token && currentUser?.email?.endsWith("@trueid.in")) {
                        localStorage.setItem("admin_email", currentUser.email);
                      }
                      navigate("/admin", { state: { fromApp: true } });
                    }}
		      sx={{
                      backgroundColor: "#2586af",
                      "&:hover": { backgroundColor: "#2586af", opacity: 0.9 },
                      borderRadius: "50px",
                      padding: { md: "6px 12px" },
                      gap: 0.5,
                      height: { md: "auto" },
                    }}
                  >
                    <AdminPanelSettingsIcon
                      fontSize="small"
                      sx={{ color: "#fff" }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#fff",
                        fontFamily: "Inter, sans-serif",
                        fontSize: { md: "14px" },
                      }}
                    >
                      Admin
                    </Typography>
                  </IconButton>
                )}
                <IconButton
                  onClick={handleSignout}
                  sx={{
                    backgroundColor: "#2586af",
                    "&:hover": { backgroundColor: "#2586af", opacity: 0.9 },
                    borderRadius: "50px",
                    padding: { md: "6px 12px" },
                    gap: 0.5,
                    height: { md: "auto" },
                  }}
                >
                  <LogoutIcon fontSize="small" sx={{ color: "#fff" }} />
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#fff",
                      fontFamily: "Inter, sans-serif",
                      fontSize: { md: "14px" },
                    }}
                  >
                    Logout
                  </Typography>
                </IconButton>
              </Box>
 
              {/* Mobile/Tablet view - menu icon for logged-in users */}
              <Box sx={{ display: { xs: "none", sm: "flex", md: "none" } }}>
                <IconButton
                  onClick={handleMenuOpen}
                  sx={{
                    backgroundColor: "#2586af",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#2586af", opacity: 0.9 },
                    padding: "8px",
                  }}
                >
                  <MenuIcon sx={{ fontSize: "24px" }} />
                </IconButton>
              </Box>
            </>
          ) : null}
        </Box>
 
        {/* Shared Menu for Mobile/Tablet - Hidden on Desktop (md+) */}
        {!isDesktop && (
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl) && !isDesktop}
            onClose={handleMenuClose}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            PaperProps={{
              sx: {
                mt: 1,
                backgroundColor: "#fff",
                "& .MuiMenuItem-root": {
                  py: 0,
                  minHeight: "auto",
                },
                "& .MuiListItemText-root": {
                  my: 0,
                },
              },
            }}
          >
            {/* Menu items for mobile (xs) only - hide on sm+ where buttons are visible */}
            <Box sx={{ display: { xs: "block", sm: "none" } }}>
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  window.location.href = "mailto:info@trueid.in";
                }}
              >
                <ListItemIcon>
                  <MailOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="info@trueid.in" />
              </MenuItem>
              <Divider />
              <MenuItem
                sx={{ mb: 1 }}
                onClick={() => {
                  handleMenuClose();
                  handleCreditsRequest();
                }}
              >
                <ListItemIcon>
                  <CallIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Contact Us" />
              </MenuItem>
            </Box>
 
            {/* User info and logout - only for logged-in users */}
            {isLoggedIn && currentUser && (
              <Box>
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                  <Divider />
                </Box>
                <MenuItem
                  disabled
                  sx={{
                    "&.Mui-disabled": {
                      opacity: 1,
                    },
                    "&.Mui-disabled .MuiListItemText-primary": {
                      color: "#000 !important",
                    },
                    "&.Mui-disabled .MuiListItemText-secondary": {
                      color: "#666 !important",
                    },
                  }}
                >
                  <ListItemIcon>
                    <AccountCircleIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      currentUser.displayName ||
                      currentUser.email?.split("@")[0] ||
                      "User"
                    }
                    secondary={currentUser.email}
                  />
                </MenuItem>
                <Divider />
		{currentUser.email.endsWith("@trueid.in") && (
                  <>
                    <MenuItem
                      onClick={() => {
                        handleMenuClose();
			// Set admin_email if user has @trueid.in email and access_token
                        const token = localStorage.getItem("access_token");
                        if (token && currentUser?.email?.endsWith("@trueid.in")) {
                          localStorage.setItem("admin_email", currentUser.email);
                        }
                        navigate("/admin", { state: { fromApp: true } });
		      }}
                    >
                      <ListItemIcon>
                        <AdminPanelSettingsIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Admin Page" />
                    </MenuItem>
                    <Divider />
                  </>
                )}


                <MenuItem onClick={handleSignout}>
                  <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Logout" />
                </MenuItem>
              </Box>
            )}
          </Menu>
        )}
      </Grid>
    {/* main content */}
      <Grid container size={12} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
        <Grid
          sx={{ textAlign: "center" }}
        >
        <Typography
            variant="h3"
            sx={{
              color: "#fff",
              fontFamily: "Inter, sans-serif",
              m: "5% auto",
              fontSize: { xs: "29px", xl: "40px" },
	    }}
          >
            Effortlessly Identify <br />
            <span style={{ fontWeight: "bold" }}>Deepfakes</span> &{" "}
            <span style={{ fontWeight: "bold" }}>AI-Generated</span> <br />
            Facial Images!
          </Typography>
          {!isLoggedIn && (
            <Grid
              container
              justifyContent={"center"}
              mt={3}
              mb={6}
            >
	    <Button
                variant="contained"
                onClick={handleSigninClick}
                sx={{
                  textTransform: "none",
                  background:
                    "transparent linear-gradient(90deg, #3768E1 0%, #50AED1 100%) 0% 0% no-repeat padding-box",
                  boxShadow: "0px 8px 6px #00000029",
                  opacity: 1,
                  color: "#fff",
                  fontSize: { xs: "13px", xl: "16px" },
                  borderRadius: "50px",
                  padding: { xs: "6px 20px", xl: "8px 30px" },
                  fontWeight: "bold",
                  "&:hover": {
                    background:
                      "transparent linear-gradient(90deg, #3768E1 0%, #50AED1 50%)",
                  },
                }}
              >
                
		  Get Started
              </Button>
            </Grid>
          )}
          {isLoggedIn && (
             <Grid container justifyContent={"center"}>
	    <Typography
                variant={{ xs: "body1", xl: "h6" }}
                sx={{
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >
                  Welcome {currentUser.displayName ||
                    currentUser.email ||
                    "User"} !
  You're all set to verify images.


              </Typography>
            </Grid>
          )}
        </Grid>
 
          <Grid container justifyContent="center" sx={{ width: "100%" }}>
	  {/* user credits */}
          <Paper
            elevation={3}
            sx={{
              background:
                "transparent radial-gradient(closest-side at 53% -13%, #3749BC 0%, #0A0E29 100%) 0% 0% no-repeat padding-box",
              boxShadow: "0px 0px 13px #1B4F6433",
              border: "1px solid #28A9E2",
              borderRadius: "20px",
              opacity: 1,
              padding: { xs: 2, sm: 3, md: 4 },
              borderRadius: "12px",
              width: { xs: "70%", sm: "50%", md: "40%", lg: "30%" },
              maxWidth: 720,
              mt: "40px",
              mx: "auto",
	    }}
          >
                <Typography
                  variant="body1"
                  textAlign="center"
                  gutterBottom
                  sx={{
                    whiteSpace: "normal",
                    fontSize: { xs: "15px", sm: "16px", md: "17px", lg: "18px" },
                    color: "#fff",
		    wordBreak: "break-word",
                  }}
                >
                  Upload the Image
                </Typography>


                {isLoggedIn && (
                  <Typography
                    variant="body2"
                    textAlign="center"
                    sx={{
                      color: "#fff",
                      fontSize: { xs: "15px", sm: "16px", md: "17px" },
                      mb: 2,
                    }}
                  >
                      {sessionExpired ? (
                      <>
                       Session Expired, please{" "}
                        <Box
                          component="span"
                          sx={{
                            cursor: "pointer",
                            color: "#28ABE2",
			    fontWeight: "bold",
		            textDecoration: "underline",			  
                          }}
                          onClick={handleSigninClick}
                        >
                          sign in
                        </Box>{" "}
                        to continue
                      </>
                    ) : creditsLoading ? (
			    "Loading credits..."
                    ) : creditsError ? (
                      <span style={{ color: "#fff" }}>{creditsError}</span>
                    ) : (
                      `You have ${userCredits || 0} check(s) left`
                    )}
                  </Typography>
                )}


                <Box marginBottom={1} sx={{ px: 1.5, display: "flex", justifyContent: "center" }}>
                  <FileUploader
                    isLoggedIn={isLoggedIn}
                    onCreditsUpdate={fetchUserCredits}
                    userCredits={userCredits}
                    onRegisterClick={handleRegisterClick}
                    onSessionExpired={handleSessionExpired}        
	  />
                </Box>
	      <Typography
              variant="body2"
              sx={{
                color: "#d9d9d9",
                fontSize: "14px",
                fontStyle: "italic",
                ml: 1,
              }}
>
              Note: Our detection engine delivers over 99% accuracy with raw,
              unfiltered, portrait images - optimized for real-world validation.
	      File size should be less than 5MB.
               </Typography>
              </Paper>
            </Grid>
          </Grid>
 
      {/* solutions */}
      <Grid>
      <Typography
          variant="h3"
          sx={{
            letterSpacing: "1px",
            font: "normal normal bold 64px/81px",
            mt: "50px",
            textAlign: "center",
            color: "#fff",
            opacity: 1,
          }}
      >
	  Our Offerings
</Typography>
      </Grid>
      <Grid container spacing={4} mt={3}>
        {solutions.map((solution, index) => (
          <Grid
            key={index}
            size={{ xs: 12, md: 4 }}
          sx={{
              background:
                "transparent radial-gradient(closest-side at 6% 93%, #3749BC 0%, #28358B 0%, #151D4E 0%, #0A0E29 100%) 0% 0% no-repeat padding-box",
              boxShadow: "0px 0px 13px #00B6FFB3",
              border: "1px solid #28A9E2",
              borderRadius: "20px",
              p: 3,
              opacity: 0.69,
            }}
            >
	    <Box
              component="img"
              src={solution.icon}
              alt={solution.title}
              sx={{ width: "50px", height: "50px", mb:1 }}
            />
		<Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: {xs:"20px", sm:"22px", md:"27px"},
	        color: "#fff",
              }}
		gutterBottom
            >
              {solution.title}
            </Typography>
            {solution.subtitle && (
              <Typography
              variant="subtitle1"
                sx={{
                  color: "#fff",
                  fontFamily: "Inter, sans-serif",
                  letterSpacing: "0.32px",
                }}
		    >
                {solution.subtitle}
              </Typography>
            )}
            <Typography variant="caption"
              sx={{ color: "#fff", fontFamily: "Inter, sans-serif" }}>
              {solution.description}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ width: "100%", mt: 5 }}>
        <Divider sx={{ border: "1px solid #458CC7", opacity: 0.6 }} />
      </Box>
      {/* footer */}
      <Grid>
        <Typography
          variant="body1"
	  sx={{ textAlign: "center", mb: 4, color: "#458CC7",py:2, fontSize: {xs:"12px", sm:"14px", md:"16px"} }}
        >
          &copy;&nbsp;{new Date().getFullYear()}&nbsp;TrueID. All Rights
          Reserved.
        </Typography>
      </Grid>
 
      {(dialogContent === "signup" || dialogContent === "signin") && (
        <AuthDialogBox open={open} onClose={handleClose}>
          <AuthForm
            initialMode={dialogContent}
	    initialEmail={contactSignupData?.businessEmail || ""}
            contactSignupData={contactSignupData}  
            onSubmit={handleAuthSuccess}
            onSuccess={(message) => showNotification(message, "success")}
            onForgotPassword={handleForgotPassword}
          />
        </AuthDialogBox>
      )}
 
      {dialogContent === "forgotPassword" && (
        <AuthDialogBox open={open} onClose={handleClose}>
          <ForgotPasswordForm
            onBack={() => setDialogContent("signin")}
            onSuccess={(message) => showNotification(message, "success")}
          />
        </AuthDialogBox>
      )}
      {(dialogContent === "request for credits" || dialogContent === "thank you message") && (
          <DialogBox
          open={open}
          onClose={handleClose}
        maxWidth={isFormAlreadySubmitted ? "500px" : isLoggedIn ? "900px" : "450px"}
	      >
          {dialogContent === "request for credits" && (
          <CreditsRequestsForm
              onClose={handleClose}
              onStatusChange={(status) => setIsFormAlreadySubmitted(status.isAlreadySubmitted)}
              onSignupTrigger={(contactData) => {
                handleClose();
                setTimeout(() => handleRegisterClick(contactData), 100);
              }}
              onShowNotification={showNotification}		  
		  />
	  )}
          {dialogContent === "thank you message" && <ThankyouMessage />}
        </DialogBox>
      )}
 
      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          icon={notification.severity === "success" ? <CheckIcon fontSize="inherit" /> : undefined}
          severity={notification.severity}
          onClose={handleCloseNotification}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};
export default MainPage;
